import React from 'react';

/**
 * One-of-N button rows. `options` = [[key, label], …].
 *   Segmented — ranges and views (.do-seg__btn)
 *   Chips     — filters (.do-hist-chip)
 */
function Choice({ options, value, onChange, cls }) {
  return options.map(([key, label]) => (
    <button key={key} type="button" className={`${cls}${value === key ? ` ${cls}--on` : ''}`}
      onClick={() => onChange(key)} aria-pressed={value === key}>{label}</button>
  ));
}

export const Segmented = ({ className = 'do-seg', ...props }) => (
  <div className={className}><Choice {...props} cls="do-seg__btn" /></div>
);

export const Chips = ({ className = 'do-hist-filter', label, children, ...props }) => (
  <div className={className} role="group" aria-label={label}>
    <Choice {...props} cls="do-hist-chip" />
    {children}
  </div>
);
